import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { t } from 'src/lib/language';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';
import { ENTITIES } from 'src/models/QuerybuilderModel';

interface Props extends ButtonProps {
  eventId?: number;
}

const DownloadTicketButton = (props: Props) => {
  const { disabled, eventId } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.tickets] || [],
  );

  const handleOpen = () => {
    dispatch(openDialog({
      dialog: DIALOGS.downloadTicket,
      payload: { eventId, ticketIds: selections },
    }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.download_ticket')}
      placement="top-start">
      <span>
        <ActionButton
          data-testid="download-ticket-button"
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.download}
          onClick={handleOpen}
          disabled={disabled || !eventId}>
          <GetAppIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default DownloadTicketButton;
